import React from 'react';
import { ColumnDefinition } from '../../components/KendoDataGrid/KendoDataGrid.types';
import { ActionsCellTemplate } from './components/ActionsCellTemplate';
import { ApprovedToReceiveCell } from './components/ApprovedToReceiveCell';
import { CustomHeaderTooltipCell } from './components/HeaderCell';
import { PrimaryCell } from './components/PrimaryCell';
import { SiteAddressCell } from './components/SiteAddressCell';
import { TextFieldCellTemplate } from './components/TextFieldCellTemplate';
import { EditableSite, SchemaOptions } from './types';

export const buildSchema = ({
  isActive,
  isInEditMode,
  actionsClass,
  isExapandAll,
  onRowClick,
  onConfirm,
  onDiscard,
  onDelete,
  onSameAsHQ,
  onDataItemExpanded,
  toggleExpandCollapseAll,
}: SchemaOptions): Array<ColumnDefinition<EditableSite>> => {
  return [
    {
      id: 'isPrimary',
      field: 'isPrimary',
      filterable: false,
      title: 'form.builder.site.information.grid.heading.isPrimary',
      headerCell: (props) => <CustomHeaderTooltipCell {...props} isTooltipHidden isShowIcon {...{ isExapandAll, toggleExpandCollapseAll }} content="form.builder.site.information.grid.heading.isPrimary" />,
      template: (props) => (
        <PrimaryCell
          isActive={false}
          {...props}
          isInEditMode={isInEditMode}
          onDataItemExpanded={onDataItemExpanded}
        />
      ),
      width: 150,
    },
    {
      id: 'siteName',
      field: 'siteName',
      title: 'form.builder.site.information.grid.heading.site.name',
      filterable: false,
      template: (props) => <TextFieldCellTemplate {...props} onClick={onRowClick} />,
      width: 200,
    },
    {
      id: 'siteAddress',
      field: 'siteAddress',
      title: 'form.builder.site.information.grid.heading.site.address',
      filterable: false,
      template: (props) => <SiteAddressCell {...props} onClick={onRowClick} onSameAsHQ={onSameAsHQ} />,
      width: 350,
    },
    {
      id: 'city',
      field: 'city',
      title: 'form.builder.site.information.grid.heading.city',
      filterable: false,
      template: (props) => <TextFieldCellTemplate {...props} onClick={onRowClick} />,
      width: 200,
    },
    {
      id: 'state',
      field: 'state',
      title: 'form.builder.site.information.grid.heading.state',
      filterable: false,
      template: (props) => <TextFieldCellTemplate {...props} onClick={onRowClick} />,
      width: 200,
    },
    {
      id: 'zipCode',
      field: 'zipCode',
      title: 'form.builder.site.information.grid.heading.zip.code',
      filterable: false,
      template: (props) => <TextFieldCellTemplate {...props} onClick={onRowClick} />,
      width: 150,
    },
    {
      id: 'country',
      field: 'country',
      title: 'form.builder.site.information.grid.heading.country',
      filterable: false,
      template: (props) => <TextFieldCellTemplate {...props} onClick={onRowClick} />,
      width: 150,
    },
    {
      id: 'approvedToReceive',
      field: 'approvedToReceive',
      title: 'form.builder.site.information.grid.heading.approved.to.receive',
      filterable: false,
      headerCell: (props) => <CustomHeaderTooltipCell {...props} content="form.builder.site.information.grid.heading.approved.to.receive" />,
      template: (props) => <ApprovedToReceiveCell {...props} onClick={onRowClick} />,
      width: 150,
    },
    {
      id: 'actions',
      title: 'actions',
      className: actionsClass,
      template: (props) => (
        <ActionsCellTemplate
          {...props}
          onConfirm={onConfirm}
          onDiscard={onDiscard}
          onDelete={onDelete}
        />
      ),
      width: 1,
    },
  ];
};
